import { useEffect, useState } from 'react'
export function useReducedMotion() {
  const [reduced, setReduced] = useState(() => matchMedia('(prefers-reduced-motion: reduce)').matches)
  useEffect(() => { const mq = matchMedia('(prefers-reduced-motion: reduce)'); const onChange = () => setReduced(mq.matches); mq.addEventListener('change', onChange); return () => mq.removeEventListener('change', onChange) }, [])
  return reduced
}
